/*!
 * Copyright 2021 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {Pipe, PipeTransform} from "@angular/core";
import {addDays} from "date-fns";

@Pipe({
  name: "toAbsDay",
  standalone: false
})
export class ToAbsDayPipe implements PipeTransform {
  transform(value: number, ...args: [string | Date | number | null | undefined]): Date | null {
    if (!args?.[0]) {
      return null;
    }

    const startDate = new Date(args[0]);
    return addDays(startDate, value);
  }
}
